import _ from 'lodash';
import update from 'react-addons-update';
import moment from 'moment';

import { roundToNextPeriod } from '../util';
import { MINUTES_IN_BLOCK } from '../components/Common/TimeSelector/TimeGrid';
import {
    SET_NEW_BOOKING_START_DATE,
    SET_NEW_BOOKING_START_TIME,
    SET_NEW_BOOKING_END_TIME,
    SET_NEW_BOOKING_PICKUP_LOCATION,
    SET_NEW_BOOKING_JOURNEY_TO_LOCATION,
    SET_NEW_BOOKING_CUSTOM_JOURNEY_TO_LOCATION,
    SET_NEW_BOOKING_TRAVEL_REASON,
    SET_NEW_BOOKING_CUSTOM_TRAVEL_REASON,
    SET_NEW_BOOKING_COST_CENTRE,
    SET_NEW_BOOKING_PLANT,
    SET_NEW_BOOKING_PLANT_TYPE,
    SET_AVAILABLE_PLANT,
    SET_NEW_BOOKING_PRIVATE_USE,
    SET_NEW_BOOKING_INITIAL_STATE,
} from '../constants';

const initialState = {
    startTime: null,
    endTime: null,
    pickupLocationId: null,
    journeyToLocationId: null,
    otherJourneyToLocation: null,
    plantTypeId: null,
    plantType: null,
    plantId: null,
    costCentreId: null,
    travelReasonId: null,
    otherTravelReason: null,
    availablePlantIds: null,
    privateUse: false,
};

const setNewBookingStartDate = (state, startDate) => {
    const currentStartTime = state.startTime;
    const currentEndTime = state.endTime;

    const newStartTime = startDate
        .clone()
        .hour(currentStartTime.hour())
        .minute(currentStartTime.minute());

    // We need to update the offset of the endTime by how much the start time changed as well, otherwise the time selector gets messed up
    const diffBetweenOriginalAndNewStartDates = newStartTime.diff(currentStartTime);
    const newEndTime = currentEndTime
        .clone()
        .add(diffBetweenOriginalAndNewStartDates);

    return update(state, {
        startTime: { $set: newStartTime },
        endTime: { $set: newEndTime },
    });
};

const setNewBookingStartTime = (state, startTime) => {
    return update(state, {
        startTime: { $set: startTime },
    });
};

const setNewBookingEndTime = (state, endTime) => {
    return update(state, {
        endTime: { $set: endTime },
    });
};

const setNewBookingPickupLocation = (state, locationId) => {
    return update(state, {
        pickupLocationId: { $set: locationId },
    });
};

const setNewBookingJourneyToLocation = (state, locationId, otherJourneyToLocation) => {
    return update(state, {
        journeyToLocationId: { $set: locationId },
        otherJourneyToLocation: { $set: otherJourneyToLocation },
    });
};

const setNewBookingTravelReason = (state, travelReasonId, otherTravelReason) => {
    return update(state, {
        travelReasonId: { $set: travelReasonId },
        otherTravelReason: { $set: otherTravelReason }
    });
};

const setNewBookingCostCentre = (state, costCentreId) => {
    return update(state, {
        costCentreId: { $set: costCentreId },
    });
};

const setNewBookingPlant = (state, plantId) => {
    return update(state, {
        plantId: { $set: plantId },
    });
};

const setNewBookingPlantType = (state, plantTypeId, plantType) => {
    return update(state, {
        plantTypeId: { $set: plantTypeId },
        plantType: { $set: plantType },
    });
};

const setAvailablePlant = (state, plantIds) => {
    return update(state, {
        availablePlantIds: { $set: plantIds },
    });
};

const setNewBookingPrivateUse = (state, privateUse) => {
    return update(state, {
        privateUse: { $set: privateUse },
    });
};

const setInitialState = (state) => {
    const start = roundToNextPeriod(moment(), MINUTES_IN_BLOCK);
    const end = start.clone().add(1, `h`);

    return update(state, {
        startTime: { $set: start },
        endTime: { $set: end },
        pickupLocationId: { $set: initialState.pickupLocationId },
        journeyToLocationId: { $set: initialState.journeyToLocationId },
        otherJourneyToLocation: { $set: initialState.otherJourneyToLocation },
        costCentreId: { $set: initialState.costCentreId },
        travelReasonId: { $set: initialState.travelReasonId },
        otherTravelReason: { $set: initialState.otherTravelReason },
        plantTypeId: { $set: initialState.plantTypeId },
        plantType: { $set: initialState.plantType },
        plantId: { $set: initialState.plantId },
        availablePlantIds: { $set: initialState.availablePlantIds },
        privateUse: { $set: initialState.privateUse },
    });
};

export default function entities(state = initialState, action) {
    switch (action.type) {
        case SET_NEW_BOOKING_START_DATE:
            return setNewBookingStartDate(state, action.startDate);
        case SET_NEW_BOOKING_START_TIME:
            return setNewBookingStartTime(state, action.startTime);
        case SET_NEW_BOOKING_END_TIME:
            return setNewBookingEndTime(state, action.endTime);
        case SET_NEW_BOOKING_PICKUP_LOCATION:
            return setNewBookingPickupLocation(state, action.locationId);
        case SET_NEW_BOOKING_JOURNEY_TO_LOCATION:
            return setNewBookingJourneyToLocation(state, action.locationId, null);
        case SET_NEW_BOOKING_CUSTOM_JOURNEY_TO_LOCATION:
            return setNewBookingJourneyToLocation(state, null, action.journeyToLocation);
        case SET_NEW_BOOKING_TRAVEL_REASON:
            return setNewBookingTravelReason(state, action.travelReasonId, null);
        case SET_NEW_BOOKING_CUSTOM_TRAVEL_REASON:
            return setNewBookingTravelReason(state, null, action.travelReason);
        case SET_NEW_BOOKING_COST_CENTRE:
            return setNewBookingCostCentre(state, action.costCentreId);
        case SET_NEW_BOOKING_PLANT:
            return setNewBookingPlant(state, action.plantId);
        case SET_NEW_BOOKING_PLANT_TYPE:
            return setNewBookingPlantType(state, action.plantTypeId, action.plantType);
        case SET_AVAILABLE_PLANT:
            return setAvailablePlant(state, action.plantIds);
        case SET_NEW_BOOKING_PRIVATE_USE:
            return setNewBookingPrivateUse(state, action.privateUse);
        case SET_NEW_BOOKING_INITIAL_STATE:
            return setInitialState(state);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./scripts/reducers/newBooking.js